import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
const { FaFilter } = require('react-icons/fa');
const { FcClearFilters } = require('react-icons/fc');

const FilterComponent = props => {
  const {
    adminNav,
    users,
    customers,
    sites,
    devices,
    views,
    setFiltered,
    filterActive,
    setFilterActive,
    formattedCameras,
    resetFilter,
    setResetFilter,
  } = props;

  const [ filterCategory, setFilterCategory ] = useState('any');
  const [ filterValue, setFilterValue ] = useState('any');
  const [ categoryArray, setCategoryArray ] = useState([]);
  const [ filterCategories, setFilterCategories ] = useState(['any']);
  const [ showFilter, setShowFilter ] = useState(false);
  const [ valueParameter, setValueParameter ] = useState('sName');

  useEffect(() => {
    if (resetFilter) {
      clearFilter()
      setResetFilter(false)
    }

    switch(adminNav) {
      case 'customers':
        setFilterCategories(['any', 'customer name'])
        break;
      case 'sites':
        setFilterCategories(['any', 'site name', 'customer name'])
        break;
      case 'devices':
        setFilterCategories(['any', 'unassigned', 'device name', 'device id', 'customer name', 'site name', 'online status', 'backend id'])
        break;
      case 'cameras':
        setFilterCategories(['any', 'camera name', 'customer name', 'site name', 'device name', 'device id', 'enabled status', 'online status'])
        break;
      case 'views':
        setFilterCategories(['any',  'view name', 'customer name', 'camera name'])
        break;
      case 'users':
        setFilterCategories(['any', 'user name', 'user email', 'customer name', 'site access', 'view name'])
        break;
      default:
        setFilterCategories(['any'])
    }

    setFilterCategory('any');
    setFilterValue('any');
    setFiltered([]);
    setFilterActive(false);

  // eslint-disable-next-line
  }, [adminNav, resetFilter])

  const clearFilter = () => {
    setFilterCategory('any');
    setFilterValue('any');
    setCategoryArray([]);
    setFilterActive(false);
    // get data without filters applied
    setFiltered([]);
    props.closeEditForm();
  };

  const arrayUniqueByKey = (key) => {
    return [...new Map(devices.map(item =>
    [item[key], item])).values()];
  }

  const handleFilterCategoryChange = async e => {
    setFilterCategory(e.target.value);

    switch(e.target.value){
      case 'any':
        setCategoryArray([]);
        break;
      case 'user name':
        setCategoryArray(users);
        setValueParameter('sDescription');
        break;
      case 'user email':
        setCategoryArray(users);
        setValueParameter('sName');
        break;
      case 'customer name':
        setCategoryArray(customers);
        setValueParameter('sName');
        break;
      case 'site name':
        setCategoryArray(sites);
        setValueParameter('sName');
        break;
      case 'site access':
        setCategoryArray(sites);
        setValueParameter('sName');
        break;
      case 'device name':
        setCategoryArray(devices);
        setValueParameter('sName');
        break;
      case 'backend id':
        let uniqueValues1 = arrayUniqueByKey('sBackendID');
        let formatted1 = uniqueValues1 && uniqueValues1.length > 0 ? uniqueValues1.map(d => ({bID: d.sBackendID, sName: d.sBackendID})) : [];
        setCategoryArray(formatted1);
        setValueParameter('sName');
        break;
      case 'device id':
        setCategoryArray(devices);
        setValueParameter('sDeviceID');
        break;
      case 'camera name':
        if(adminNav === 'views'){
          let cams = await formattedCameras.map( c => ({...c, sName: `${c.sDeviceName} : ${c.sName}`}));
          setCategoryArray(cams);
          setValueParameter('sName');
          setFilterValue('any');
          return;
        };
        setCategoryArray(formattedCameras);
        setValueParameter('sName');
        break;
      case 'view name':
        setCategoryArray(views);
        setValueParameter('sName');
        break;
      case 'online status':
        setCategoryArray([{bID: 2, sName: 'online'}, {bID: 1, sName: 'offline'}]);
        setValueParameter('sName');
        break;
      case 'enabled status':
        setCategoryArray([{bID: 2, sName: 'enabled'}, {bID: 1, sName: 'disabled'}]);
        setValueParameter('sName');
        break;
      default:
        setCategoryArray([]);
    };

    setFilterValue('any');
  };

  const handleFilterValueChange = e => {
    setFilterValue(e.target.value);
  };

  const filter = async () => {
    props.closeEditForm();
    // get data with filters applied
    let tempArray = [...categoryArray]; // this is whatever data  we are being provided to filter

    // essentialy reset the category and show all the data
    if(filterValue === 'any' && filterCategory !== 'unassigned'){
      if(adminNav === 'cameras'){
        tempArray = formattedCameras;
      };
      if(adminNav === 'views'){
        tempArray = views;
      };
      setFiltered(tempArray);
      setFilterActive(false);
      return;
    };

    switch (filterCategory){
      case 'any':
        setFiltered(tempArray);
        setFilterActive(false);
        break;
      case 'site access':
        // this only happens on user page
        tempArray = await users.filter(user => (user['access'].map(a => a.bProjectID)).includes(parseInt(filterValue)));
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'customer name':
        if(adminNav === 'users'){
          tempArray = await users.filter(user => user.bCustomerID === parseInt(filterValue));
        };
        if(adminNav === 'customers'){
          tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        };
        if(adminNav === 'sites'){
          tempArray = await sites.filter(item => item.bCustomerID === parseInt(filterValue));
        };
        if(adminNav === 'devices'){
          tempArray = await devices.filter(item => item.bCustomerID === parseInt(filterValue));
        };
        if(adminNav === 'cameras'){
          tempArray = await formattedCameras.filter(item => item.bCustomerID === parseInt(filterValue));
        };
        if(adminNav === 'views'){
          tempArray = await views.filter(item => item.bCustomerID === parseInt(filterValue));
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'site name':
        if(adminNav === 'sites'){
          tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        };
        if(adminNav === 'devices'){
          tempArray = await devices.filter(item => item.bCustomerProjectID === parseInt(filterValue));
        };
        if(adminNav === 'cameras'){
          tempArray = await formattedCameras.filter(item => item.bCustomerProjectID === parseInt(filterValue));
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'view name':
        if(adminNav === 'users'){
          tempArray = await users.filter(user => user.sViews.includes(parseInt(filterValue)));
        };
        if(adminNav === 'views'){
          tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'device name':
        if(adminNav === 'devices'){
          tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        };
        if(adminNav === 'cameras'){
          tempArray = await formattedCameras.filter(item => item.bDeviceID === parseInt(filterValue));
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'device id':
        if(adminNav === 'devices'){
          tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        };
        if(adminNav === 'cameras'){
          tempArray = await formattedCameras.filter(item => item.bDeviceID === parseInt(filterValue));
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'backend id':
        if(adminNav === 'devices'){
          tempArray = await devices.filter(item => item.sBackendID === filterValue);
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'online status':
        if(adminNav === 'devices'){
          tempArray = await devices.filter(item => item.fOnline === parseInt(filterValue) - 1);
        };
        if(adminNav === 'cameras'){
          tempArray = await formattedCameras.filter(item => item.fOnline === parseInt(filterValue) - 1);
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'enabled status':
        if(adminNav === 'cameras'){
          tempArray = await formattedCameras.filter(item => item.fEnabled === parseInt(filterValue) - 1);
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'unassigned':
        if(adminNav === 'devices'){
          tempArray = await devices.filter(item => !item.bCustomerProjectID);
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      case 'camera name':
        if(adminNav === 'cameras'){
          tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        };
        if(adminNav === 'views'){
          tempArray = await views.filter(item => (JSON.parse(item.sCams)).includes(parseInt(filterValue)));
        };
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
        break;
      default:
        // this should be the usual case - outliers specified above
        tempArray = await tempArray.filter(item => item.bID === parseInt(filterValue));
        setFiltered(tempArray && tempArray.length > 0 ? tempArray : []);
        setFilterActive(true);
    };
  }

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        {!showFilter &&
          <>
            <FaFilter style={{...styles.pointer, color: filterActive ? 'mediumseagreen' : 'grey'}} onClick={() => setShowFilter(true)}/>
            <p style={styles.filterText} onClick={() => setShowFilter(true)}>{filterActive ? 'Filtered By: ' : 'Filter'}</p>
            { filterActive &&
              <p style={styles.filterText}>
                [{filterCategory}, {categoryArray.find(c => c.bID === parseInt(filterValue)) ? categoryArray.find(c => c.bID === parseInt(filterValue)).sName : 'any'}]
              </p>
            }
          </>
        }

        {showFilter &&
          <>
            <FcClearFilters style={styles.pointer} onClick={() => setShowFilter(false)} />
            <div style={styles.filterGroup}>
              <p style={styles.filterText}>Category:</p>
              <select value={filterCategory} onChange={handleFilterCategoryChange}>
                {filterCategories.map(c => (
                    <option key={c} value={c}>{c}</option>
                  ))
                }
              </select>
            </div>
            {filterCategory !== 'unassigned' &&
              <div style={styles.filterGroup}>
                <p style={styles.filterText}>Value:</p>
                <select value={filterValue} onChange={handleFilterValueChange}>
                  <option value={'any'}>any</option>
                  {categoryArray.map( c => (
                      <option key={c.bID} value={c.bID}>{c[valueParameter] && c[valueParameter].length > 0 ? c[valueParameter] : '???'}</option>
                    ))
                  }
                </select>
              </div>
            }
            <button style={styles.pointer} onClick={filter}>Filter</button>
            </>
        }

        {filterActive && <button style={styles.pointer} onClick={clearFilter}>X</button>}
      </div>
    </div>
  )
};

const mapStateToProps = state => {
  const { adminNav } = state.config;
  return { adminNav }
}

export default connect(mapStateToProps)(FilterComponent)

const styles = {
  container: {
    display: 'flex',
    fontSize: '1.6vmin',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '2vmin',
    border: '2px solid grey',
    borderRadius: 5,
    padding: '0 1vmin',
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1vmin',
  },
  filterText: {
    cursor: 'pointer',
    margin: 0,
    padding: '.5vmin 1vmin',
  },
  pointer: {
    cursor: 'pointer',
  },
}